'use client';

import { FullStory, isInitialized, getSessionAsync } from '@fullstory/browser';


// FullStory is initialized lazily on idle (see FullStoryEffect), and in embed
// mode the SDK is loaded asynchronously by the shim, so events fired on mount
// (e.g. ErrorPage) would throw or be dropped. Queue them until the first
// successful flush after init; keep queueing until then to preserve order.
const pendingEvents = [];
let isReady = false;

const trackEvent = ({ eventName, data }) => {
  try {
    FullStory('event', {
      name: eventName,
      properties: data,
    });
  } catch (error) {
    console.log('FullStory track event error: ', error);
  }
};

export const setFSCustomEvent = (eventName, data) => {
  if (!isReady) {
    pendingEvents.push({ data, eventName });
    return;
  }

  trackEvent({ data, eventName });
};

export const flushFSPendingEvents = () => {
  if (!isInitialized()) {
    return;
  }

  isReady = true;
  pendingEvents.splice(0).forEach(trackEvent);
};

export const getFullStorySession = async (format = 'url') => {
  try {
    const session = await FullStory('getSessionAsync', { format });
    return session;
  } catch (e) {
    console.error('Failed to get FullStory session', e);
    return null;
  }
};